/** Tabla visual Round Robin con el look del póster (Eduardo 2026-10-15):
 * mismos textos cortos que lib/drawPoster («vie 16 oct», «18:00 · Cancha 1»,
 * «1 vs 4 · vie 16:00 C1»). Solo texto: el marcado vive en la página. */

import { posterDay, posterTime } from "./drawPoster";

export function rrCourtLong(court: string | null | undefined): string {
  const c = (court ?? "").trim();
  return /^\d+$/.test(c) ? `Cancha ${c}` : c;
}

export function rrCourtShort(court: string | null | undefined): string {
  const c = (court ?? "").trim();
  return /^\d+$/.test(c) ? `C${c}` : c;
}

/** Celda pendiente: «vie 16 oct» arriba y «18:00 · Cancha 1» abajo. */
export function rrWhen(date: string | null, time: string | null, court: string | null): { day: string; rest: string } {
  return {
    day: posterDay(date),
    rest: [posterTime(time), rrCourtLong(court)].filter(Boolean).join(" · "),
  };
}

/** Renglón del rol de juegos: «vie 16:00 C1» (o «por programar»). */
export function rrRolWhen(date: string | null, time: string | null, court: string | null): string {
  const weekday = posterDay(date).split(" ")[0] ?? "";
  const text = [weekday, posterTime(time), rrCourtShort(court)].filter(Boolean).join(" ");
  return text || "por programar";
}

/** Partido con ganador pero sin marcador: «W.O.», «DEF» o «Jugado». */
export function rrNoScoreLabel(status: string): string {
  if (status === "walkover" || status === "no_show") return "W.O.";
  if (status === "defaulted") return "DEF";
  if (status === "retired") return "Retiro";
  return "Jugado";
}
